// Select

$(function () {

    function bind() {
        const $navsToSelect = $('.jsNavsToSelect');

        $navsToSelect.each(function () {
            const $currentNavigation = $(this);
            const $navItems = $currentNavigation.find('.nav-item');
            const $selectTag = $('<select class="custom-select" />');
            const $placeHolder = $currentNavigation.data('placeholder');
            const $target = $currentNavigation.closest('.jsNavsToSelectTarget');

            $currentNavigation.after($selectTag);

            $selectTag.append($('<option></option>'));
            $navItems.each(function () {
                const $this = $(this);
                const $navLink = $this.find('.nav-link');
                const $option = $('<option>' + $this.text() + '</option>');

                $option.attr('value', $navLink.text());
                $option.attr('data-href', $navLink.attr('href'));
                $option.attr('data-ajax-href', $navLink.data('ajax-href'));
                $selectTag.append($option);
                if ($this.hasClass('active')) {
                    $selectTag.val($navLink.text());
                }
            });

            $currentNavigation.remove();

            $selectTag.select2({
                language: 'cs',
                theme: 'default',
                minimumResultsForSearch: Infinity,
                placeholder: $placeHolder,
                width: '100%'
            });

            $selectTag.on('change', function (e) {
                const $selected = $("option:selected", this)
                const href = $selected.data('href');
                const ajaxHref = $selected.data('ajax-href');
                if (typeof ajaxHref !== 'undefined') {
                    EUCUtils.reload(ajaxHref, $target, href);
                    return;
                }
                else if (typeof href !== 'undefined') {
                    window.location.href = href;
                }
            });
        });
    }


    bind();

    $(document).bind("reload:completed", bind);
});

